"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Content = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_components.FeedbackDialog)(() => ({
  [`.${_mui.paperClasses.root}`]: {
    width: '500px'
  }
}));
const Content = exports.Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4)
}));